<template>
  <section style="">
    <div id="mundo">
      <img src="~@/assets/bola_mundo.png" alt="" />
    </div>
    <div class="columns is-centered">
      <div
        class="column is-5-desktop is-8-tablet is-12-mobile content"
        style="z-index: 10;"
      >
        <div class="container section">
          <b class="title is-5 is-pink">
            {{ $t('Estado de su solicitud') }}
          </b>
          <options-viewer :optionsObject="neofintechData.phase2" />
          <div v-if="requestData.status == 'P2-P'" class="container">
            <div class="columns is-centered">
              <GridLoader
                style="margin-top: 20px; margin-bottom: 20px;"
                color="#de4282"
              />
            </div>
          </div>
          <div
            v-if="requestData.status == 'P3-S'"
            class="container has-text-centered"
            style="margin-top: 30px;"
          >
            <p>
              {{ $t('STATUS_RESULTS_1') }}
            </p>
            <p>
              {{ $t('STATUS_RESULTS_2') }}
            </p>
            <button
              type="button"
              @click="goToPhase3"
              native-type="submit"
              id="continua-btn"
              class="button is-primary is-large pulse"
            >
              {{ $t('Continuar') }}
            </button>
          </div>
          <div
            v-else-if="requestData.status == 'P2-NR'"
            class="container has-text-centered"
            style="margin-top: 30px;"
          >
            <p>
              {{ $t('STATUS_NO_RESULTS_1') }}
            </p>
            <p>
              {{ $t('STATUS_NO_RESULTS_2') }}
            </p>
            <p>
              {{ $t('STATUS_NO_RESULTS_3') }}
            </p>
            <p>
              {{ $t('STATUS_NO_RESULTS_4') }}
            </p>
          </div>
          <div
            v-else-if="requestData.status == 'P2-NMI'"
            class="container has-text-centered"
            style="margin-top: 30px;"
          >
            <p>
              {{ $t('STATUS_MAYBE_1') }}
            </p>
            <p>
              {{ $t('STATUS_MAYBE_2') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnumeratesFormater from '@/mixins/enumeratesFormater.js'
import OptionsViewer from '@/components/on-board/OptionsViewer.vue'
import GridLoader from 'vue-spinner/src/GridLoader.vue'

export default {
  props: ['id'],
  mixins: [EnumeratesFormater],
  components: { OptionsViewer, GridLoader },
  data() {
    return {
      requestData: {
        status: 'P2-P'
      }
    }
  },
  mounted() {
    this.loadRequestData()
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    this.$store.commit('onBoard/SET_NEOFINTECH_PHASE_1_RESET')
    this.$store.commit('onBoard/SET_NEOFINTECH_PHASE_2_RESET')
    next()
  },
  methods: {
    ...mapActions('onBoard', ['getOnboardRequestDetails']),
    loadRequestData: async function() {
      let self = this

      const response = await self.getOnboardRequestDetails(this.id)
      self.requestData = response.data
      if (response.data.status == 'P2-P') {
        await new Promise(resolve => setTimeout(resolve, 2000))
        await self.loadRequestData()
      } else {
        self.$store.commit(
          'onBoard/SET_NEOFINTECH_PHASE_2',
          response.data.phase2
        )
      }
    },
    goToPhase3: function() {
      let self = this
      self.$router.push({
        name: 'onBoard.neofintech.phase3.congratulations'
      })
    }
  }
}
</script>

<style>
#mundo {
  position: fixed;
  top: 60;
  right: -100px;
  width: 60vh;
  z-index: 0;
}
</style>
